import React from 'react';
import { Card, Flex, Paper, Skeleton, Stack, Text, Title } from '@mantine/core';
import Button from '../../components/elements/Button';
import styles from './styles.scoped.css';
import IconSubMerchant from '../../components/icons/IconSubMerchant';
import IconBlock from '../../components/icons/IconBlock';
import IconSecure from '../../components/icons/IconSecure';
import PropTypes from 'prop-types';
import { renderStatusRegistration, renderStatusSubMerchant } from './FoundSubMerchant';
import { STATUS_SUB_MERCHANT_VERIF } from '../../utils/constants';

export const RenderTopIdentitySubMerchant = ({
  setModal,
  setDetailType,
  detailType,
  dataContent,
  isLoading
}) => {

  return(
    <Card>
      <Flex justify="space-between" mb="md" wrap="wrap">
        <Stack spacing="xs">
          <Flex align="center" gap="sm" >
            <Title order={4}>{dataContent?.storeName || '-'}</Title>
            {renderStatusSubMerchant(dataContent?.registrationStatus,
              dataContent?.isBlocked,
              dataContent.isContractAgreed)}
          </Flex>
          <Text>ID Subpangkalan: <b>{dataContent?.subPangkalanId}</b></Text>
        </Stack>
        <Flex gap="sm" justify="flex-end" wrap="wrap">
          <Button className={styles.btnTopAction}
            disabled={!(dataContent?.registrationStatus === STATUS_SUB_MERCHANT_VERIF.ACTIVE
               && dataContent.isContractAgreed)
               || isLoading}
            onClick={() => setModal({
              type: dataContent?.isBlocked === 1 ? 'confirmUnblock' : 'block',
              opened: true
            })} style={dataContent?.isBlocked === 1 ? 'default' : 'light-danger'}>
            <Flex align="center" gap="xs" justify="center">
              <IconBlock/>
              {dataContent?.isBlocked === 1 ? 'Buka Blokir Subpangkalan' : 'Blokir Subpangkalan'}
            </Flex>
          </Button>
          <Button className={styles.btnTopAction}
            disabled={dataContent.isBlocked && true || isLoading}
            onClick={() => setModal({
              type: 'confirmPin',
              opened: true
            })}
          >
            <Flex align="center" gap="xs" justify="center">
              <IconSecure/>
            Atur Ulang PIN
            </Flex>
          </Button>
          <Button className={styles.btnTopAction} disabled={isLoading}
            onClick={() => setDetailType(detailType === 'masked' ? 'plain' : 'masked')}>
            <Flex align="center" gap="xs" justify="center">
              <img
                alt={detailType === 'masked' ? 'show' : 'hide'}
                height={10}
                src={`/assets/ic-password-${detailType === 'masked' ? 'show' : 'hide'}-white.svg`}
                width={15}
              />
              {detailType === 'masked' ? 'Tampilkan Data' : 'Sembunyikan Data'}
            </Flex>
          </Button>
        </Flex>
      </Flex>
      {renderStatusRegistration(dataContent?.registrationStatus,
        dataContent?.isBlocked, dataContent?.blockedReason, dataContent?.isContractAgreed)}
    </Card>
  );
};

RenderTopIdentitySubMerchant.propTypes = {
  dataContent: PropTypes.object,
  detailType: PropTypes.oneOf(['masked', 'plain']),
  isLoading: PropTypes.bool,
  setDetailType: PropTypes.func,
  setModal: PropTypes.func,
};

export const RenderDataIdentityList = ({
  title = 'Data Identitas',
  withBorder = false,
  withTitleIcon = false,
  listContent = [],
  isLoading
}) => {

  return(
    <Card m={withBorder ? 'md' : 'none'} withBorder={withBorder}>
      <Flex gap="sm">
        {withTitleIcon &&
        <Paper bg="#EBF1E1" display="flex" p={8} radius={15} style={{ alignItems: 'center', height: 'max-content' }}>
          <IconSubMerchant/>
        </Paper>}
        <Title fz={24} mb="sm" order={3}>
          {title}
        </Title>
      </Flex>
      <table>
        {listContent.map((item, idx) => (
          <tr key={idx}>
            <td className={styles.listLabel}>
              <Text fw={500} fz={18}>{item.label}</Text>
            </td>
            <td>:</td>
            <td>{(isLoading && item.needLoadingState)
              ? <Skeleton height={22} width={122}/> :item.value}</td>
          </tr>
        ))}
      </table>
    </Card>
  );
};

RenderDataIdentityList.propTypes = {
  isLoading: PropTypes.bool,
  listContent: PropTypes.array,
  title: PropTypes.string,
  withBorder: PropTypes.bool,
  withTitleIcon: PropTypes.bool,
};

